import getConfig from 'next/config';

// Only holds serverRuntimeConfig and publicRuntimeConfig
const config = getConfig()

// Get from env var if set, otherwhise get from next env vars
export const API_URL = config ? config?.publicRuntimeConfig?.PUBLIC_API_URL : "";